<template>
  <div class="container-fluid py-5 text-center">
    <!-- Header -->
    <div class="d-flex flex-column align-items-center justify-content-center">
      <i class="bi bi-shield-lock text-danger display-1 mb-3"></i>
      <h1 class="fw-bold text-danger">Accès refusé</h1>
      <p class="text-muted fs-5 mt-2">
        Vous n’avez pas les droits nécessaires pour accéder à cette page.
      </p>

      <!-- Boutons -->
      <div class="mt-4 d-flex gap-3 flex-wrap justify-content-center">
        <router-link to="/" class="btn btn-primary px-4">
          <i class="bi bi-house-door me-2"></i> Retour au tableau de bord
        </router-link>
        <router-link to="/login" class="btn btn-outline-danger px-4">
          <i class="bi bi-box-arrow-in-right me-2"></i> Se connecter avec un autre compte
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unauthorized",
};
</script>

<style scoped>
.container-fluid {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
